import { useEffect, useRef } from 'react'

// Fires a callback once when an easytabs panel becomes visible.
// Needed because easytabs renders all panels on mount and toggles via CSS,
// so React lifecycle hooks alone cannot detect when a panel is actually shown.
function useEasytabsVisibility(panelId, callback) {
  const firedRef = useRef(false)
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    const panel = document.getElementById(panelId)
    if (!panel) return undefined

    const fire = () => {
      if (firedRef.current) return
      firedRef.current = true
      callbackRef.current()
    }

    if (panel.classList.contains('is-active')) {
      fire()
      return undefined
    }

    const observer = new MutationObserver(() => {
      if (panel.classList.contains('is-active')) fire()
    })

    observer.observe(panel, { attributes: true, attributeFilter: ['class'] })

    return () => observer.disconnect()
  }, [panelId])
}

export default useEasytabsVisibility
